// Carga seQura tras analizar el DOM, sin bloquear los demás scripts diferidos.
(() => {
  const shop = document.currentScript?.dataset.shop;
  if (!shop || window.MPSequraLoader || window.sequraWidgetsScriptLoaded) return;

  // Si se reactiva el embed de la app, dejamos que cargue su propio script.
  if (document.querySelector('script[src*="sma.lis.sequra.com/scripts/widgets"]')) return;
  window.MPSequraLoader = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://sma.lis.sequra.com/scripts/widgets?shop=${encodeURIComponent(shop)}`;
  document.head.appendChild(script);
})();
